@if(isPageInitialized) {
  <div class="cost-tracking-wrapper" *transloco="let t; prefix: 'costTracking'">
    <div class="page-header d-flex align-items-center justify-content-between">
      <h1>{{ t('title') }}</h1>

      <div class="filters-section d-flex align-items-center gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        <div class="common-drop-down date-height" [class.d-none]="isTabActive('budget') || isTabActive('asset-cost')">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>

        @if (isTabActive('asset-cost')) {
          <app-search
            [placeholder]="t('table.searchAsset')"
            [searchTerm]="assetCostSearchTerm"
            [customWidth]="'220px'"
            (searchTermUpdated)="onAssetCostSearchTermUpdate($event)">
          </app-search>
        }

        @if (isTabActive('budget')) {
          <app-search
            [placeholder]="t('table.searchAsset')"
            [searchTerm]="budgetSearchTerm"
            [customWidth]="'220px'"
            (searchTermUpdated)="onBudgetSearchTermUpdate($event)">
          </app-search>

          <span ngbDropdown class="filter-dropdown" [autoClose]="true">
            <button type="button" class="btn form-control dropdown-toggle filter-input" id="budgetCategoryFilterDropdown"
              [disabled]="isLoadingBudgetCategories" ngbDropdownToggle>
              <div class="d-flex flex-row justify-content-between align-items-center gap-2">
                <span class="align-middle">{{ budgetCategoryLabel }}</span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="budgetCategoryFilterDropdown" class="dropdown-menu-custom">
              <button type="button" class="btn btn-outline dropdown-item-custom" (click)="onBudgetCategorySelect(null)" ngbDropdownItem>
                {{ t('budgetTable.filters.allCategories') }}
              </button>
              @for (category of budgetCategories; track category.id) {
                <button type="button" class="btn btn-outline dropdown-item-custom" (click)="onBudgetCategorySelect(category)" ngbDropdownItem>
                  {{ category.name | lookupLabel:budgetCategoryLabels }}
                </button>
              }
            </div>
          </span>
        }

        <button type="button" class="btn-set-budget" (click)="onSetBudget()">
          <span>{{ t('setBudget') }}</span>
        </button>
      </div>
    </div>

    <div class="tabs-container w-100" role="tablist">
      @if (showCostDistributionTab) {
        <button type="button" class="tab-button" role="tab" [attr.aria-selected]="isTabActive('cost-distribution')"
          [class.active]="isTabActive('cost-distribution')" (click)="onTabChange('cost-distribution')">
          {{ t('tabs.costDistribution') }}
        </button>
      }
      <button type="button" class="tab-button" role="tab" [attr.aria-selected]="isTabActive('budget')"
        [class.active]="isTabActive('budget')" (click)="onTabChange('budget')">
        {{ t('tabs.budget') }}
      </button>
      <button type="button" class="tab-button" role="tab" [attr.aria-selected]="isTabActive('asset-cost')"
        [class.active]="isTabActive('asset-cost')" (click)="onTabChange('asset-cost')">
        {{ t('tabs.assetCost') }}
      </button>
    </div>

    @if (showCostDistributionTab && hasVisited('cost-distribution')) {
      <div class="tab-pane" [class.d-none]="!isTabActive('cost-distribution')">
        <!-- Widgets Row -->
        <div class="widgets-section">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <app-total-repair-costs [selectedFilter]="getSelectedFilterLabel()"></app-total-repair-costs>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <app-total-insurance-cost [selectedFilter]="getSelectedFilterLabel()"></app-total-insurance-cost>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <app-total-compliance-costs [selectedFilter]="getSelectedFilterLabel()"></app-total-compliance-costs>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <app-annual-budget [selectedFilter]="getSelectedFilterLabel()"></app-annual-budget>
            </div>
          </div>
        </div>

        <div class="graphs-section">
          <div class="row">
            <div class="col-xl-4 col-lg-5 col-md-12">
              <app-cost-distribution-reactive-preventive></app-cost-distribution-reactive-preventive>
            </div>
            <div class="col-xl-8 col-lg-7 col-md-12">
              <app-cost-distribution-category></app-cost-distribution-category>
            </div>
          </div>
        </div>

        <div class="graphs-section">
          <div class="row">
            <div class="col-xl-6 col-lg-12">
              <app-maintenance-trend></app-maintenance-trend>
            </div>
            <div class="col-xl-6 col-lg-12">
              <app-budgeted-vs-actual></app-budgeted-vs-actual>
            </div>
          </div>
        </div>
      </div>
    }
    @if (hasVisited('budget')) {
        <div class="table-section" [class.d-none]="!isTabActive('budget')">
          <app-budget-table
            [searchTerm]="budgetSearchTerm"
            [budgetCategoryId]="selectedBudgetCategory?.id ?? null"
            (editBudget)="onEditBudget($event)">
          </app-budget-table>
        </div>
    }
    @if (hasVisited('asset-cost')) {
        <div class="table-section" [class.d-none]="!isTabActive('asset-cost')">
          <app-asset-cost-table [pageSize]="10" [searchTerm]="assetCostSearchTerm"></app-asset-cost-table>
        </div>
    }
  </div>
}